module.exports = __webpack_public_path__ + "static/media/ic_arrow_upward_24px.6b76c47c.svg";